import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { RemoteControlService, RemoteControlKey } from '../remote';
import { PlayerState } from '../player/state/player.reducer';
import { AuthService } from '../core/auth.service';

import { ActivationHelper } from '../activation/activation.helper';
@Component({
  selector: 'app-promo',
  templateUrl: './promo.component.html',
  styleUrls: ['./promo.component.scss'],
})
export class PromoComponent implements OnInit {
  remoteMonitor!: Subscription;

  qrcode!: string;
  imgQrCode!: string;
  message1!: string;
  message2!: string;

  timeout!: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private playerStore: Store<PlayerState>,
    private remote: RemoteControlService,
    private authService: AuthService
  ) {
    this.watchRemoteControlKeys();
  }

  ngOnInit(): void {
    //this.playerStore.dispatch(fromPlayerActions.PlayerStopped());
    this.checkUser();
  }

  public checkUser() {
    let timeoutUser: any;
    let errStatus: any;
    this.authService.getQrCode().subscribe({
      next: (response: any) => {
        clearTimeout(timeoutUser);
        if (response.Code) {
          // TODO: quanto ativar o modo de produção com a claro descomentar
          this.message1 = ''; //'Já é assinante Only TV?';
          this.message2 = ''; //'Leia o QR code ou acesse connect.onlytv.tv no seu navegador e digite o código abaixo';
          this.qrcode = ''; // response.Code;
          localStorage.setItem('QRCode', response.Code);
        }
        // TODO: quanto ativar o modo de produção com a claro descomentar
        this.imgQrCode = ''; //'assets/img/QRCode.svg';
        this.payingsubscriber();
      },
      error: (err) => {
        this.message1 = 'Estamos quase lá!';
        this.message2 =
          'Acesse o canal 250 ou entre em contato com a Claro para adquirir nosso pacote OnlyTV Arabe';
        this.qrcode = '';
        this.imgQrCode = '';
        errStatus = err.status;
        if (errStatus == 401) {
          // this.router.navigate(['/home']);
          timeoutUser = setTimeout(() => {
            this.payingsubscriber();
          }, 5 * 1000);
        } else {
          this.router.navigate(['/']);
        }
      },
    });
  }

  public payingsubscriber() {
    this.authService.statuspayingsubscriber().subscribe((res: any) => {
      //console.log('payingsubscriber**************: ', res);
      //this.lerLocalStorage();
      if (!res.IsValid) {
        clearTimeout(this.timeout);
        const access = {
          DeviceGuid: ActivationHelper.getSavedGuid(),
          DeviceHeader: ActivationHelper.getSaveUserAgent(),
        };
        this.authService.sign(access).subscribe({
          next: (res) => res,
          error: (e) => {
            this.timeout = setTimeout(() => {
              this.checkUser();
            }, 5 * 1000);
          },
        });
      } else {
        // TODO: quanto ativar o modo de produção com a claro descomentar e remover 'this.router.navigate(['/home'])'
        // this.timeout = setTimeout(() => {
        //   this.payingsubscriber();
        // }, 3 * 1000);
        this.router.navigate(['/home'])
      }
    });
  }

  public lerLocalStorage(): void{
    for (let index = 0; index < localStorage.length; index++) {
      console.log("LocalStorage: ", index,localStorage.getItem(String(localStorage.key(index))))
    }
  }

  private watchRemoteControlKeys(): void {
    this.remoteMonitor = this.remote.OnKeyPress.subscribe((re) => {
      // Disable welcome message and focus on first channel

      if (re.RemoteKey === RemoteControlKey[RemoteControlKey.OK]) {
        // TODO melhorar retorno para home
        //this.playerStore.dispatch(fromPlayerActions.StopRequest());
        //this.router.navigate(['/activation']);
      } else if (re.RemoteKey === RemoteControlKey[RemoteControlKey.One]) {
        // TODO: mode de resetar localstorage
        if (localStorage.getItem('restPasswordOne') == undefined) {
          localStorage.setItem('restPasswordOne', 'one');
        } else {
          localStorage.removeItem('restPasswordOne');
          localStorage.removeItem('restPasswordFive');
          localStorage.removeItem('restPasswordNine');
        }
        this.authService.resetPassword();
      } else if (re.RemoteKey === RemoteControlKey[RemoteControlKey.Five]) {
        // TODO: mode de resetar localstorage
        if (localStorage.getItem('restPasswordFive') == undefined) {
          localStorage.setItem('restPasswordFive', 'five');
        } else {
          localStorage.removeItem('restPasswordOne');
          localStorage.removeItem('restPasswordFive');
          localStorage.removeItem('restPasswordNine');
        }
        this.authService.resetPassword();
      } else if (re.RemoteKey === RemoteControlKey[RemoteControlKey.Nine]) {
        // TODO: mode de resetar localstorage
        if (localStorage.getItem('restPasswordNine') == undefined) {
          localStorage.setItem('restPasswordNine', 'nine');
        } else {
          localStorage.removeItem('restPasswordOne');
          localStorage.removeItem('restPasswordFive');
          localStorage.removeItem('restPasswordNine');
        }
        this.authService.resetPassword();
      } else if (re.RemoteKey === RemoteControlKey[RemoteControlKey.Zero]) {
        this.authService.resetPassword();
      }
    });
  }
}
